import * as React from "react";
import { ICON_GLYPHS } from "./icon-glyphs";

/**
 * Phosphor icon glyph (Grackle DS: regular weight; fill only for play/pause and status dots).
 * Use for every icon in Grackle; never hand-draw SVG icons or use emoji / unicode symbols.
 * Every literal `name` must be listed in clients/ui/icons.txt (the font is subset to it).
 */
export interface IconProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** Phosphor icon name, e.g. "video-camera", "caret-down" (phosphoricons.com, without `ph-`) */
  name: string;
  /** px, default 20 */
  size?: number;
  /** Filled weight (play/pause, status dots, and an active or selected state) */
  fill?: boolean;
}

export function Icon({ name, size = 20, fill = false, className, style, ...rest }: IconProps): JSX.Element {
  // A name missing from icons.txt renders an empty box rather than its name as text;
  // scripts/check-icons.mjs catches literal names in CI.
  const cp = ICON_GLYPHS[name];
  return (
    <span
      aria-hidden="true"
      data-icon={name}
      className={["gk-icon", fill && "gk-icon--fill", className].filter(Boolean).join(" ")}
      style={{ fontSize: size, width: size, height: size, ...style }}
      {...rest}
    >
      {cp === undefined ? null : String.fromCodePoint(cp)}
    </span>
  );
}
